import Http from '../../../../http';

// eslint-disable-next-line import/prefer-default-export
export const fetchCustomerMembershipSubscription = (ownerType, ownerId, customerId) => (
  Http.get(`/${ownerType}/${ownerId}/memberships/members/${customerId}`)
);
